import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import PortableText from "./portableText";
import SocialShare from "./social-share";
import SubscriptionForm from "./subscription-form";
import { format } from "date-fns";

import * as styles from "../styles/components/main-content.module.css";

const NewsMain = (props) => {

  const {
    content,
    author,
    date,
    title
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        <div className="grid">
          <div className="col-12 col-md-7 col-lg-6">
            <div className="content-xl">
              {content && <PortableText blocks={content} />}
            </div>
          </div>
          <div className={cn("col-12 col-md-4 col-xl-3 offset-md-1 offset-lg-2 offset-xl-3", styles.sidebar)}>
            <div className="entry-content">
              {(author || date) &&
                <div className={cn(styles.item, styles.author)}>
                  <div className={styles.authorImageContainer}>
                    {author && author.featuredImage && <img src={author.featuredImage.asset.url} alt={author.featuredImage.alt} className={styles.authorImage}/>}
                    <div>
                      {author && <>By <span>{ ' ' + author.name}</span></>}
                      <div>{date && <>written on <span>{format(new Date(date).setDate(new Date(date).getDate() + 1), "MMMM d, yyyy")}</span></>}</div>
                    </div>
                  </div> 
                 {author && author.bio && <p className={styles.bioContainer}> { author.bio }</p>}
                </div>
              }
              <SubscriptionForm title={title} />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="content-xl">
              <SocialShare title={title} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default NewsMain;
